"use client";

import React, { useState } from "react";
//import Link from "next/link";
//import Image from "next/image";
import DonationsView from "../../components/Donations";
import { ArrowLeft, ChevronDown, ChevronUp } from "lucide-react";
import { Button } from "../../components/ui/button";
import spcaImage from "../../assets/images/donations/1.png";
import tearsImage from "../../assets/images/donations/2.png";
import greenImage from "../../assets/images/donations/3.png";
import foodImage from "../../assets/images/donations/4.png";
import saveImage from "../../assets/images/donations/5.png";
import hopeImage from "../../assets/images/donations/6.png";
import animalImage from "../../assets/images/donations/7.png";
import treeImage from "../../assets/images/donations/8.png";
import waterImage from "../../assets/images/donations/9.png";
import aidImage from "../../assets/images/donations/10.png";
import thanksImage from "../../assets/images/donations/thankDonation.svg";

import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Switch } from "../../components/ui/switch";
import infoIcon2 from "../../assets/icons/info_icon.svg";
import { Separator } from "../../components/ui/separator";
import logoSmall from "../../assets/images/logoSmallGrey.svg";
import padlockIcon from "../../assets/icons/padlock.svg";
import DonationsList from "../../components/DonationsList";

export default function Donations() {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20"
            onClick={() => {
              navigate("/settings/index");
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium"> / Donations</p>
        </div>
        <DonationsList />
      </div>
    </>
  );
}
